<script>
// Public: IE11 doesn't support foreignObject, so we add this to avoid complete
// failure when attempting to access Floorplans.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject#Browser_compatibility
export default {
  name: 'ForeignObject',
  render () { return null },
}
</script>
